import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env/insitestore360';

@Component({
  selector: 'app-image-display',
  standalone: true,
  imports: [CommonModule, HttpClientModule],
  templateUrl: './image-display.component.html',
  styleUrl: './image-display.component.scss',
})
export class ImageDisplayComponent implements OnInit {
  imageSrc: string | null = null;
  isLoading = true;
  hasError = false;
  imageAlt = '';

  constructor(private http: HttpClient, private router: Router) { }

  ngOnInit(): void {
    const href = this.router.url;
    const urlArray = href.split('/');
    this.imageAlt = `${urlArray[2]} - ${urlArray[3]}`;
    this.fetchImage(urlArray[2], urlArray[3]);
  }

  fetchImage(containerName: string, filename: string): void {
    const blobUrl = `${environment.BLOB_URL}/${containerName}/${filename}`;
    const url = `${environment.BLOB_URL}/getFile?blobUrl=${encodeURIComponent(blobUrl)}`;
    this.isLoading = true;
    this.hasError = false;

    const headers = new HttpHeaders().set('isBlob', 'true');
    this.http.get(url, { headers, responseType: 'blob' }).subscribe({
      next: (blob: Blob) => {
        // Check if blob is valid and not too large
        if (blob.size > 10 * 1024 * 1024) { // 10MB limit
          console.warn('Image size exceeds 10MB, consider compression');
        }

        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          this.imageSrc = reader.result as string;
          this.isLoading = false;
        };
        reader.onerror = () => {
          this.handleImageError('Failed to read image data');
        };
      },
      error: (error) => {
        this.handleImageError(`Error fetching image: ${error.message || 'Unknown error'}`);
      }
    });
  }

  private handleImageError(errorMessage: string): void {
    console.error(errorMessage);
    this.hasError = true;
    this.isLoading = false;
    this.imageSrc = null;
  }

  onImageLoad(): void {
    this.isLoading = false;
  }

  onImageError(): void {
    this.handleImageError('Failed to load image');
  }
}
